import { Helmet } from "react-helmet";
import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { DataContext } from "../../AppLayout";
import CapitalFirstLetter from "../../utils/capitalFirst";
import "./style.scss";

const Specifications = () => {
  const { setVariant, setActiveIndex, setLoading } = useContext(DataContext);
  const { category, modalNo } = useParams();
  const [folderLocation, setFolderLocation] = useState(null);
  const [productData, setProductData] = useState({
    images: null,
    ideal_for: null,
    peak_power: [],
    power_title: null,
    features_top: [],
    applications: [],
    specifications: [],
    features_bottom: [],
  });

  useEffect(() => {
    const getDataFromApi = async () => {
      setVariant(true);
      setActiveIndex(1);
      let url = `/database/media/categories/${category.replaceAll(
        "+",
        " "
      )}/specs/${String(modalNo).toUpperCase().replaceAll("+", " ")}.json`;
      let res = await fetch(url, { method: "GET" });
      let data = await res.json();
      let productData = data.data;
      setProductData(data.data);
      setFolderLocation(productData["folder_location"]);
      setLoading(false);
    };

    getDataFromApi();
  }, [category, modalNo, setVariant, setActiveIndex, setLoading]);

  let {
    images,
    ideal_for,
    peak_power,
    power_title,
    features_top,
    applications,
    specifications,
    features_bottom,
  } = productData;

  let specTableRow = "";
  if (specifications) {
    specTableRow = Math.round(specifications.length / 2);
    specTableRow = `repeat(${specTableRow}, 1fr)`;
  }

  let pickPowerCol = "";
  if (peak_power) {
    pickPowerCol = `repeat(${peak_power.length}, 1fr)`;
  }

  // const breadcrumbLinks = [
  //   {
  //     title: "home",
  //     link: "/",
  //   },
  //   {
  //     title: "products",
  //     link: "/products",
  //   },
  //   {
  //     title: category,
  //     link: "/products/" + category,
  //   },
  //   {
  //     title: modalNo,
  //     lastLink: true,
  //   },
  // ];

  let mainWidth = window.innerWidth;
  let sliderWidth = mainWidth > 768 ? mainWidth / 2 - 80 : `${mainWidth - 60}`;

  return (
    <div className="specifications-page container main-margin">
      <Helmet>
        <title>
          {CapitalFirstLetter(
            modalNo.toUpperCase() + " " + category.replaceAll("+", " ")
          )}
        </title>
        <meta
          name="keywords"
          content={
            modalNo.toUpperCase() +
            ", " +
            "n-labs, ohm, warranty, class, specifications, peak, rms, continues, ratan, tata, power, features, ideal for, applications, 8,4,2"
          }
        />
        <meta
          name="description"
          content={
            "The N-labs " +
            modalNo.toUpperCase() +
            " " +
            category.replaceAll("+", " ") +
            " specification and information page which contains applications, outputs, power outputs and capabilities, etc."
          }
        />
      </Helmet>

      <div className="fixWithGrid col2" style={{ alignItems: "flex-start" }}>
        <div>
          <h1 className="fix-align-center">{productData["title"]}</h1>
          <div className="slider" style={{ width: sliderWidth }}>
            {images && (
              <div>
                <a
                  href={folderLocation + images[0]}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    alt={"n-labs " + productData["title"]}
                    src={folderLocation + images[0]}
                  />
                </a>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="mobile-spacer">
            <div className="vspacer4" />
          </div>
          <div
            className="fixWithFlex"
            style={{ flexWrap: "wrap", gap: "var(--spacing4)" }}
          >
            {features_top &&
              features_top.map(({ label, value }, index) => {
                return (
                  <div key={"features_" + index}>
                    <h2>{label}</h2>
                    <h6 className="text-normal fix_value">{value}</h6>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {peak_power && (
        <>
          <div className="vspacer4" />
          <div className="vspacer4" />

          <div className="details">
            <h3>{power_title ? power_title : "PEAK POWER"}</h3>
            <div className="vspacer4" />
            <div className="vspacer4" />
            <div
              className="fixWithGrid fix-mobile-peak-power"
              style={{ gridTemplateColumns: pickPowerCol }}
            >
              {peak_power &&
                peak_power.map(({ label, value }, index) => {
                  return (
                    <div key={"peak_power_" + index}>
                      <h5 className="text-normal">{label}</h5>
                      <div className="vspacer2" />
                      <h3 className="info">{value}</h3>
                    </div>
                  );
                })}
            </div>
            <div className="vspacer4" />
          </div>
        </>
      )}

      {specifications && (
        <>
          <div className="vspacer4" />
          <div className="vspacer4" />

          <div className="specs">
            <div>
              <h3>Specifications</h3>
            </div>

            <div className="vspacer4" />

            <div
              className="specTable"
              style={{ gridTemplateRows: specTableRow }}
            >
              {specifications &&
                specifications?.map(({ label, value }, index) => {
                  return (
                    <div key={"specs_" + index} className="fixWithFlex">
                      <div style={{ flexGrow: 1 }}>{label}</div>
                      <div className="info">{value}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}

      {features_bottom && (
        <>
          <div className="vspacer4" />
          <div className="vspacer4" />

          <div className="features">
            <div>
              <h3>FEATURES </h3>
            </div>

            <div className="vspacer4" />

            <div>
              <ul>
                {features_bottom &&
                  features_bottom.map(({ label }, index) => {
                    return (
                      <li key={"fb_" + index}>{String(label).toLowerCase()}</li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </>
      )}

      {ideal_for && (
        <>
          <div className="vspacer4" />
          <div className="vspacer4" />

          <div className="ideal_for">
            <h3>IDEAL FOR</h3>
            <div className="vspacer4" />
            <div className="vspacer3" />

            <div className="fixWithGrid col3">
              {ideal_for &&
                ideal_for.map(({ label, value }, index) => {
                  return (
                    <div key={"if_" + index}>
                      <h4 className="info">{label}</h4>
                      <p>{value}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}

      {applications && (
        <>
          <div className="vspacer4" />
          <div className="vspacer4" />

          <div className="ideal_for">
            <h3>APPLICATIONS</h3>

            <div className="vspacer4" />
            <div className="vspacer3" />

            <div className="fixWithGrid col3">
              {applications &&
                applications.map(({ label, value }, index) => {
                  return (
                    <div key={"app_" + index}>
                      <h4 className="info">{label}</h4>
                      <p>{value}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Specifications;
